import { makeAutoObservable } from 'mobx';

import { TUserProfile } from 'app/railways/domains/profile/core';

import { UPermissionsName } from '../../core/permissions';

export class PermissionStore {
  private permSet = new Set<UPermissionsName>();

  get perms() {
    return this.permSet;
  }

  constructor() {
    makeAutoObservable(this);
  }

  private mapUserPerms(userData: TUserProfile): Set<UPermissionsName> {
    const permSet = new Set<UPermissionsName>();

    for (const role of userData.roles) {
      for (const perm of role.permissions) {
        permSet.add(perm.name);
      }
    }

    return permSet;
  }

  public fromUser(userProfile: TUserProfile) {
    const result = this.mapUserPerms(userProfile);

    this.permSet = result;
  }
}
